export const LANGUAGE = "language";
export const SUBSTATION = "substation";
export const NETWORK = "network";
export const DROPDOWN_WIDTH = 322;


export const flagMap: Record<string, string> = {
  en: "GB",
  sv: "SE",
  da: "DK",
};
